import Vue from "vue";
import Vuex from "vuex";

import biensModule from "./modules/biensModule";
import dataModule from "./modules/dataModule";
import userModule from "./modules/userModule";
import likeModule from "./modules/likeModule";
import notificationModule from "./modules/notificationModule"

Vue.use(Vuex);

const state = {};
const getters = {};
const mutations = {};
const actions = {};

const modules = {
  biensModule,
  dataModule,
  userModule,
  likeModule,
  notificationModule
};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules
});
